import { ValueObject } from '@/engine/core/valueObject';
import type { IConfigProps, IReportConfig } from './interfaces';

export type IReportConfigProps = IReportConfig;

/**
 * Represents a report configuration.
 */
export class ReportConfig extends ValueObject<IReportConfigProps> implements IReportConfig {
  public constructor(props: IReportConfigProps) {
    super(props);
  }

  /**
   * Gets default DPI for screenshots.
   */
  public get imagesDPI(): number {
    return this.props.imagesDPI;
  }

  /**
   * Gets the name of the procedure.
   */
  public get procedureName(): string {
    return this.props.procedureName;
  }

  /**
   * Gets the entries of the report configuration.
   */
  public get entries(): Map<string, IConfigProps> {
    return this.props.entries;
  }
}
